import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
  slides = [
    // {img: "/assets/img/slider/02.png"},
    // {img: "/assets/img/slider/03.png"},
    {img: "/assets/img/slider/04.png"},
    {img: "/assets/img/slider/05.png"},
    // {img: "/assets/img/slider/06.png"},
    {img: "/assets/img/slider/07.png"}
  ];

  slideConfig = { "lazyLoad": 'ondemand', "slidesToShow": 1, "slidesToScroll": 1, "arrows": true, "trueautoplay": true, "autoplaySpeed": 2000 };
  constructor() { }

  ngOnInit(): void {
  }

}
